import React from 'react'
import { Navbar } from '@sketch/components'
import { PrototypeControls } from '../PrototypeControls'
import * as S from './PrototypeFooter.styles'
import { usePrototypeContext } from '../../hooks'
import { EnterFullScreenButton } from '../EnterFullScreenButton'
import { ResizeModeSelector } from '../ResizeModeSelector'

export function PrototypeFooter() {
  const { isFullscreen } = usePrototypeContext()

  if (isFullscreen) {
    return null
  }

  return (
    <S.FooterNavbar data-testid="prototype-footer">
      <Navbar.Section align="end">
        <S.Item>
          <PrototypeControls />
        </S.Item>
        <S.Item>
          <ResizeModeSelector />
        </S.Item>
        <S.Item>
          <EnterFullScreenButton />
        </S.Item>
      </Navbar.Section>
    </S.FooterNavbar>
  )
}
